var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatInputMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60357 7.87929C4.77046 7.24591 7.24591 4.77046 7.87929 1.60357L8 1L8.12071 1.60357C8.75409 4.77046 11.2295 7.24591 14.3964 7.87929L15 8L14.3964 8.12071C11.2295 8.75409 8.75409 11.2295 8.12071 14.3964L8 15L7.87929 14.3964C7.24591 11.2295 4.77046 8.75409 1.60357 8.12071L1 8L1.60357 7.87929Z",
    fill: "url(#paint0_linear_0_62)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_62",
    x1: 5.69149,
    y1: 11.7312,
    x2: 13.1631,
    y2: 11.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817308,
    stopColor: "#1CDA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInputMark);
export default __webpack_public_path__ + "static/media/chat_input_mark.d2f4c49079e4de9305ab62abd093cac7.svg";
export { ForwardRef as ReactComponent };